import { render, staticRenderFns } from "./CameraGBS.vue?vue&type=template&id=2baac9ba&scoped=true&"
import script from "./CameraGBS.vue?vue&type=script&lang=js&"
export * from "./CameraGBS.vue?vue&type=script&lang=js&"
import style0 from "./CameraGBS.vue?vue&type=style&index=0&id=2baac9ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baac9ba",
  null
  
)

export default component.exports